import { render, staticRenderFns } from "./OPR.vue?vue&type=template&id=63195b64&scoped=true"
import script from "./OPR.vue?vue&type=script&lang=js"
export * from "./OPR.vue?vue&type=script&lang=js"
import style0 from "./OPR.vue?vue&type=style&index=0&id=63195b64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63195b64",
  null
  
)

export default component.exports